'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index$3 = require('../index.js');

var isMotionValue = function (value) {
  return value instanceof index$3.MotionValue;
};

exports.isMotionValue = isMotionValue;
